import * as yup from 'yup';

const ConditionsSchema = {
    conditions: yup
        .array()
        .of(
            yup.object().shape(
                {
                    attribute: yup.string().when(['operator', 'value'], {
                        is: true,
                        then: yup
                            .string()
                            .required(
                                'FLEXCONTROLSCONDITIONSATTRIBUTEREQUIRED',
                            ),
                    }),
                    operator: yup.string().when(['attribute', 'value'], {
                        is: true,
                        then: yup
                            .string()
                            .required('FLEXCONTROLSCONDITIONSOPERATORREQUIRED'),
                    }),
                    value: yup.string().when(['attribute', 'operator'], {
                        is: true,
                        then: yup
                            .string()
                            .required('FLEXCONTROLSCONDITIONSVALUEREQUIRED'),
                    }),
                },
                [
                    ['operator', 'attribute'],
                    ['operator', 'value'],
                    ['attribute', 'value'],
                ],
            ),
        )
        .when('type', {
            is: 'restriction',
            then: yup
                .array()
                .of(
                    yup.object().shape({
                        attribute: yup
                            .string()
                            .required('FLEXCONTROLSCONDITIONSATTRIBUTE'),
                        operator: yup
                            .string()
                            .required('FLEXCONTROLSCONDITIONSOPERATOR'),
                        value: yup
                            .string()
                            .required('FLEXCONTROLSCONDITIONSVALUE'),
                    }),
                )
                .required('FLEXCONTROLSCONDITIONS'),
        }),
};

export default ConditionsSchema;
